import { SearchUser } from '@root/entities/search-user'

import type { ActivityFollowerDetailDto } from '@root/shared/api/TradeApi'
import type { AvatarsHost } from '@root/shared/models'

export interface FollowerDetail extends SearchUser.SearchUser {
  mentionsCount: number
  likesCount: number
  deployedTokensCount: number
}

export const fromDto = (
  dto: ActivityFollowerDetailDto,
  avatarsHost: AvatarsHost,
): FollowerDetail => {
  return {
    ...SearchUser.fromDto(
      { ...dto, followersCount: dto.followers, followingCount: dto.following },
      avatarsHost,
    ),
    mentionsCount: dto.mentionsCount,
    likesCount: dto.likesCount,
    deployedTokensCount: dto.deployedTokensCount,
  }
}
